import React from 'react'
import type { SbEditableContent } from 'storyblok-react'
import { type StoryblokRichtext } from 'storyblok-rich-text-react-renderer'
import RichText from 'src/utils/RichText'

export type ItemVariantTypes = 'primary' | 'secondary' | 'tertiary'

export interface PillarItemProps extends SbEditableContent {
  icon: string
  text: StoryblokRichtext[]
  variant?: ItemVariantTypes
}

// @INFO: Color styles for each variant based on the Figma design
const ItemVariant: Record<ItemVariantTypes, string> = {
  primary: 'bg-teal-1000 text-white',
  secondary: 'bg-[#00577E] text-white',
  tertiary: 'bg-darkgreen text-darkblue'
}

export const PillarItem = ({ icon, text, variant = 'primary' }: PillarItemProps) => {
  const variantClasses = ItemVariant[variant]

  return (
    <div className={`w-[350px] h-32 px-6 py-12 flex items-center gap-3 ${variantClasses} rounded-lg shadow-lg font-light`}>
      <div className="flex-shrink-0 w-12 h-12">
        <img src={icon} alt="Item icon" className="w-full h-full object-contain" />
      </div>
      <div className="text-md">
        <RichText>{text}</RichText>
      </div>
    </div>
  )
}

PillarItem.displayName = 'Pillar Item'